var modules_e5ab2127 = {"container":"RegionDialog_module_container__41698c15","content":"RegionDialog_module_content__41698c15","menu":"RegionDialog_module_menu__41698c15","listWrapper":"RegionDialog_module_listWrapper__41698c15","list":"RegionDialog_module_list__41698c15","listItem":"RegionDialog_module_listItem__41698c15","regionButton":"RegionDialog_module_regionButton__41698c15"};
import "../assets/CkoTUpEd.css";

export { modules_e5ab2127 as default };
//# sourceMappingURL=RegionDialog.module.less.js.map
